const getBasePicturePath = (src) => {
  const imagePath = src.match(/(upload.*)/)[0];
  let basePath = imagePath.replace("standard_", "large_");
  basePath = basePath.replace("thumb_", "large_");

  return basePath;
};

const ImgixLoader = ({ src, width }) => {
  // https://lecloset.imgix.net/uploads/picture/image/prd_4R3Yur/standard_IMG_7385.jpg?w=200&q=80&auto=format
  const apiEndPoint = 'https://lecloset.imgix.net';
  const imagesPath = src.match(/(upload.*)/);
  if (!imagesPath) return "";

  const basePath = getBasePicturePath(src);
  const transform = `w=${width}&q=75&auto=format`;
  const transformedImageUrl = `${apiEndPoint}/${basePath}?${transform}`;
  return transformedImageUrl;
};

export default ImgixLoader;
